module.exports = __webpack_public_path__ + "static/media/same_books.d7b36e0b.png";